import { Component, HostListener } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'alpha-loader',
    standalone: true,
    imports: [],
    template: `<img src="assets/images/Neutrinos-loader.gif" class="w-10rem h-auto" alt="loader" />`,
})
export class LoaderComponent {
    static disabled = environment.DISABLE_LOADER;
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}
